export const AI_STUDIO_CUSTOM_APP_SCOPE = 'AIStudio';
export const AI_CREATIVE_TOOLS_CUSTOM_APP_SCOPE = 'AICreativeTools';

export interface AICustomApp {
    readonly aiCustomAppID: number;
    readonly name: string;
    readonly description?: string | null;
    readonly mediaFactoryAppID: number;
    readonly isActive: boolean;
}

export interface MadooEditorSavedPayload {
    name: string;
    workflowExternalId: string;
    workflowGuid: string;
    workflowInterfaceId?: string;
    requestId?: string;
}
